<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="breadcrumb-main user-member justify-content-sm-between">
        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
          <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
            <h4 class="text-capitalize fw-500 breadcrumb-title">{{ title }}</h4>
          </div>
        </div>
        <div class="action-btn d-flex flex-wrap align-items-center">
          <slot name="actions" />
        </div>
      </div>
    </div>
    <div class="col-lg-12 mb-3">
      <nav class="inv-subnav">
        <router-link to="/invoice" class="inv-subnav__link" active-class="inv-subnav__link--active" exact>
          <i class="fas fa-file-invoice"></i> Daftar
        </router-link>
        <router-link to="/invoice/customers" class="inv-subnav__link" active-class="inv-subnav__link--active">
          <i class="fas fa-users"></i> Customer
        </router-link>
        <router-link to="/invoice/settings" class="inv-subnav__link" active-class="inv-subnav__link--active">
          <i class="fas fa-cog"></i> Pengaturan
        </router-link>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'Modul Invoice' }
  }
};
</script>
